import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUsage } from "@/hooks/useUsage";
import { useWorkspace } from "@/hooks/useWorkspace";
import { UpgradeDialog } from "@/components/UpgradeDialog";

const WARN_THRESHOLD = 0.8;

export const UsageWarningBanner = () => {
  const { active } = useWorkspace();
  const { downloadsThisMonth, limits, downloadsAtLimit } = useUsage();
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const [dismissed, setDismissed] = useState<Record<string, boolean>>({});

  if (!active) return null;
  if (limits.downloadsPerMonth === null) return null;

  const downloadPct = limits.downloadsPerMonth ? downloadsThisMonth / limits.downloadsPerMonth : 0;
  const downloadWarn = downloadPct >= WARN_THRESHOLD && !downloadsAtLimit;
  if (!downloadWarn) return null;

  const key = `${active.id}:d:${downloadsThisMonth}`;
  if (dismissed[key]) return null;

  return (
    <>
      <div className="border-b border-amber/40 bg-amber/15 text-foreground">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-2.5 flex items-center gap-3 text-sm">
          <AlertTriangle className="h-4 w-4 shrink-0 text-amber" />
          <p className="flex-1 min-w-0">
            You've used <strong>{downloadsThisMonth} of {limits.downloadsPerMonth} Excerpt Image downloads</strong> this month. Upgrade for a higher monthly cap.
          </p>
          <Button size="sm" variant="outline" className="h-7 px-3" onClick={() => setUpgradeOpen(true)}>
            Upgrade
          </Button>
          <button
            onClick={() => setDismissed((d) => ({ ...d, [key]: true }))}
            className="p-1 rounded hover:bg-amber/20 transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
      <UpgradeDialog open={upgradeOpen} onOpenChange={setUpgradeOpen} tier="Plus" feature="Higher monthly Excerpt Image downloads" />
    </>
  );
};
